import { I18n } from "@/i18n/I18n";
import { Dropdown } from 'react-bootstrap';

export function DuplicateItem(props: { onClickDupe: () => void }) {
  const { onClickDupe } = props;

  return (
    <Dropdown.Item
        aria-label={I18n.get('duplicate')}
        onClick={onClickDupe}
      >
        {I18n.get('duplicate')}
    </Dropdown.Item>
  );
};
